import type { AppProps } from 'next/app'
import { useRouter } from 'next/router'
import { appWithTranslation } from 'next-i18next'
import { QueryClient, QueryClientProvider } from 'react-query'

import { FaviconTags } from '@cash-web/favicon'
import type { Region } from '@cash-web/shared-ui-region-provider'
import { RegionProvider } from '@cash-web/shared-ui-region-provider'
import { SquareupCommonCountries } from '@cash-web/shared-util-protos'

import Layout from '../app/Layout'
import i18nextConfig from '../next-i18next.config'
import { AnalyticsProvider } from '../src/contexts/Analytics'
import { start } from '../src/lib/bugsnag'

const queryClient = new QueryClient()

start()

const HelpCenterApp = (props: AppProps) => {
  const { Component, pageProps } = props
  const router = useRouter()

  const region =
    SquareupCommonCountries.Country[router.query['region']?.toString().toUpperCase()] ??
    SquareupCommonCountries.Country.US

  return (
    <>
      <FaviconTags />

      <QueryClientProvider client={queryClient}>
        <RegionProvider region={region as Region}>
          <AnalyticsProvider>
            <Layout>
              <Component {...pageProps} />
            </Layout>
          </AnalyticsProvider>
        </RegionProvider>
      </QueryClientProvider>
    </>
  )
}

export default appWithTranslation(HelpCenterApp, i18nextConfig)
